import _extends from "@babel/runtime-corejs3/helpers/extends";
export function omit(obj, fields) {
  var shallowCopy = _extends({}, obj);

  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }

  return shallowCopy;
}